/**
 * Internal dependencies.
 */
import edit from './edit';
// import save from './save';
import metadata from './block.json';

/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';
import { Icon } from '@wordpress/components';

/**
 * Block constants
 */
const { name, category, attributes } = metadata;

const settings = {
	title: __( 'Map' ),
	description: __( 'Create beautiful map section.' ),
	icon: <Icon icon="location-alt" />,
	keywords: [
		'gutenify',
		__( 'map' ),
	],
	example: {
		attributes: {
		},
	},
	attributes,
	edit,
	save: () => {},
	supports: {
		html: false,
		align: [ 'center', 'wide', 'full' ],
	},
};

export { name, category, settings };
